import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { OAuthService } from 'angular-oauth2-oidc';
import { WindowWrapperService } from '@awin/shared';
import { HttpParams } from '@angular/common/http';
import { getNetworkGroup, NavigationState } from '@awin/navigation-renderer';
import { select, Store } from '@ngrx/store';
import { first } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthorizedGuard  {
  constructor(
    private oAuthService: OAuthService,
    private windowWrapperService: WindowWrapperService,
    private store: Store<NavigationState>,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | Observable<boolean> {
    const claims = this.oAuthService.getIdentityClaims();
    const authorised =
      this.oAuthService.hasValidAccessToken() &&
      (claims?.['https://awin.com/userId'] ?? claims?.['sub']);

    return authorised ? of(true) : this.navigateToOidc(state);
  }

  private navigateToOidc(state: RouterStateSnapshot): boolean {
    this.store
      .pipe(select(getNetworkGroup), first())
      .subscribe((networkGroup: string) => {
        const params: HttpParams = new HttpParams({
          fromObject: {
            route: state.url,
            locale:
              this.windowWrapperService.nativeWindow.location.pathname.split(
                '/',
              )[2],
            networkGroup,
          },
        });
        this.windowWrapperService.nativeWindow.location.href =
          '/communication-centre/en/awin/oidc?' + params.toString();
      });

    return false;
  }
}
